import { render, staticRenderFns } from "./JournalEditing.vue?vue&type=template&id=706d4cdc&scoped=true&"
import script from "./JournalEditing.vue?vue&type=script&lang=js&"
export * from "./JournalEditing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d4cdc",
  null
  
)

export default component.exports